const GLEAP_API_KEY = 'U7ijNKXX0Z0xdWSP2Hkx9wvmkFnTq39E';

let gleapInitialized = false;
let pendingUserIdentification = null;

// Initialize Gleap and immediately identify user (prevents Guest sessions)
export const initGleapWithUser = (user, company = null) => {
  if (!user) return;
  
  // Store user data for identification after SDK loads
  pendingUserIdentification = { user, company };
  
  // If already initialized and not destroyed, just identify the user
  if (window.Gleap && gleapInitialized && typeof window.Gleap.identify === 'function') {
    identifyGleapUser(user, company);
    return;
  }
  
  // Reset if Gleap was destroyed
  if (window.Gleap && window.Gleap.invoked && !gleapInitialized) {
    // Gleap was destroyed, need to re-initialize
    delete window.Gleap;
  }
  
  // Load Gleap SDK
  (function() {
    if (!(window.Gleap = window.Gleap || []).invoked) {
      window.GleapActions = [];
      var e = new Proxy({ invoked: true }, {
        get: function(e, n) {
          return "invoked" === n ? e.invoked : function() {
            var e = Array.prototype.slice.call(arguments);
            window.GleapActions.push({ e: n, a: e });
          };
        },
        set: function(e, n, t) {
          return e[n] = t, true;
        }
      });
      window.Gleap = e;
      var n = document.getElementsByTagName("head")[0];
      var t = document.createElement("script");
      t.type = "text/javascript";
      t.async = true;
      t.src = "https://sdk.gleap.io/latest/index.js";
      n.appendChild(t);
      
      // Wait for script to load, then initialize AND identify user immediately
      t.onload = function() {
        window.Gleap.initialize(GLEAP_API_KEY);
        
        // Hide feedback button until user is identified (prevents guest sessions)
        window.Gleap.showFeedbackButton(false);
        
        gleapInitialized = true;
        
        // Immediately identify user after initialization to prevent Guest session
        if (pendingUserIdentification) {
          identifyGleapUser(pendingUserIdentification.user, pendingUserIdentification.company);
          pendingUserIdentification = null;
        }
      };
    }
  })();
};

// Legacy function for backward compatibility
export const initGleap = () => {
  console.warn('initGleap() is deprecated. Use initGleapWithUser(user, company) instead.');
};

export const identifyGleapUser = (user, company = null) => {
  if (!user || !window.Gleap) return;
  const identityData = {
    name: `${user.first_name || ''} ${user.last_name || ''}`.trim() || 'Unknown',
    email: user.email || '',
    companyId:company?.id?.toString() || '',
    companyName: company?.name || '',
    phone: user.team_member?.phone || '',
    plan: company?.subscription?.type || ''
  };

  window.Gleap.identify(user?.team_member?.id || user?.team_member_id, identityData);
  
  // Show feedback button only after user is identified
  window.Gleap.showFeedbackButton(true);
};

// Update user's company data after they select a company
export const updateGleapContact = (company) => {
  if (!window.Gleap || !company) return;
  
  window.Gleap.updateContact({
    companyId: company.id?.toString() || '',
    companyName: company.name || '',
    plan: company.subscription?.type || ''
  });
};

export const clearGleapUser = () => {
  if (window.Gleap) {
    // Hide feedback button first
    window.Gleap.showFeedbackButton(false);
    // Clear user identity - this ends the current session
    window.Gleap.clearIdentity();
    // Disable Gleap completely to prevent guest session after logout
    window.Gleap.destroy();
  }
  // Reset initialization state so Gleap can be re-initialized for next user
  gleapInitialized = false;
  pendingUserIdentification = null;
};

export default {
  initGleap,
  initGleapWithUser,
  identifyGleapUser,
  updateGleapContact,
  clearGleapUser,
};
